import { useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export default function NewsletterSignup({ source = "blog" }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = (email || "").trim();
    if (!trimmed || !trimmed.includes("@")) {
      setStatus("error");
      setMessage("Podaj poprawny adres email");
      return;
    }
    setStatus("loading");
    setMessage("");
    try {
      const res = await axios.post(`${BACKEND_URL}/api/public/newsletter/subscribe`, {
        email: trimmed,
        source,
      });
      if (res.data?.ok) {
        setStatus("success");
        if (res.data.already_active) {
          setMessage("Już subskrybujesz nasz newsletter!");
        } else if (res.data.resent_confirmation) {
          setMessage("Wysłaliśmy ponownie email potwierdzający. Sprawdź skrzynkę.");
        } else {
          setMessage("Sprawdź skrzynkę i potwierdź subskrypcję klikając w link.");
        }
        setEmail("");
      } else {
        setStatus("error");
        setMessage(res.data?.error || "Coś poszło nie tak");
      }
    } catch (err) {
      setStatus("error");
      setMessage(err.response?.data?.detail || "Błąd połączenia, spróbuj ponownie");
    }
  };

  return (
    <div className="my-12 p-8 bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-2xl">
      <div className="max-w-2xl mx-auto text-center">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          📬 Newsletter Epidemos
        </h3>
        <p className="text-gray-600 mb-6">
          Najnowsze artykuły, tipsy SEO i automatyzacji — raz w tygodniu na Twoim mailu.
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="twój@email.pl"
            disabled={status === "loading"}
            className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none disabled:opacity-50"
            required
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
          >
            {status === "loading" ? "Wysyłam..." : "Zapisz się"}
          </button>
        </form>
        {message && (
          <p className={`mt-4 text-sm ${status === "success" ? "text-green-700" : "text-red-600"}`}>
            {message}
          </p>
        )}
        <p className="mt-4 text-xs text-gray-500">
          Bez spamu. Wypiszesz się jednym kliknięciem.
        </p>
      </div>
    </div>
  );
}
